<template>
  <div class="flex w-full items-center pb-4 text-base" :class="{ '-mt-2': !props.isSingleItem }">
    <div v-if="props.option.name || props.option.groupParameter" class="truncate font-semibold">{{ props.option.name || props.option.groupParameter }}</div>
    <Price v-if="props.option.price" class="ml-auto" :amount="props.option.price" />
  </div>
  <template v-if="(props.option && !props.option.isOptionAvailable) || props.option.isOptionAvailable === null">
    <div v-if="props.option.isOptionAvailable === 0" class="-mt-3 mb-4 text-sm text-text-attention">{{ t['w.global.product_option.not_available']() }}</div>
    <div v-else-if="props.option.isOptionAvailable === null" class="-mt-3 mb-4 text-sm text-text-attention">{{ t['w.global.product_option.not_available_variation']() }}</div>
  </template>
</template>

<script setup lang="ts">
import Price from '~/components/price/Price.vue'
import * as t from '~/messages'

const props = defineProps({
  option: {
    type: Object,
    default: null,
  },
  hideTitle: {
    type: Boolean,
    default: false,
  },
  isSingleItem: {
    type: Boolean,
    default: null,
  },
})
</script>
